import { Injectable } from '@angular/core';
import { GS1Document } from '../models/document.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "environments/environment";
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { LogoPartenairesVM } from '../models/logo.model';
 let __URL_API__  = `${environment.URL_API}`; 

@Injectable({providedIn: 'root'})
export class DocumentService {

    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) { }

    async getCGA(): Promise<GS1Document[]> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetCGA'));
            return response as  GS1Document[] ;
        } catch (error) {
            return await this.handleError(error);
        }
    }
    async getCGU(): Promise<GS1Document> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetCGU'));
            return response as GS1Document;
        } catch (error) {
            return await this.handleError(error);
        }
    }
    async getCGV(): Promise<GS1Document> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetCGV'));
            return response as GS1Document;
        } catch (error) {
            return await this.handleError(error);
        }
    }
    async getPolitiqueConfidentialite(): Promise<GS1Document> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetPolitiqueConfidentialite'));
            return response as GS1Document;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getPackDocuments(): Promise<GS1Document[]> {
        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetPackDocuments'));
            return response as GS1Document[];
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async searchMesDocuments(skip: number = 0, limit: number = 10): Promise<{ count: number, data: GS1Document[] }> {
        var params = new HttpParams()
            .set('skip', skip)
            .set('limit', String(limit));

        try {
            let response = await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetMesDocuments', { params }));
            return response as { count: number, data: GS1Document[] };
        } catch (error) {
            return await this.handleError(error, 'MesDocuments.PROBLEME_RECUPERATION_DOCUMENTS');
        }

    }


    async DownloadDocument(idDoc: string) {
        try {
            
            let url: string = __URL_API__ + 'api/Document/DownloadFile/' + idDoc;
            window.open(url, "_self");
        } catch (err) {
            this.handleError(err, 'Une erreur est survenue lors de la récupération du document demandé');
        }
    }
    async DownloadCGA() {
        let fileName = "Conditions Générales d'Adhésion - GS1 France";
        try {
            let data =  await lastValueFrom(this._http.get(__URL_API__ + 'api/Document/GetPdfCGA',{ responseType: 'blob' as const }));
            var file = new Blob([data as any], { type: 'application/pdf' })
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL); 
            var a         = document.createElement('a');
            a.href        = fileURL; 
            a.target      = '_blank';
            a.download    = fileName;
            document.body.appendChild(a);
            a.click();
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async DisplayDocument(idDoc: string) {
        
            let url: string = __URL_API__ + 'api/Document/DisplayFile/' + idDoc;
            return url;
       
    }



    private handleError(error: any, message: string = 'GlobalErrors.default'): Promise<any> {
        this.notificationService.addNotification(this.translate.instant(message), 'error');
        return Promise.reject(error.message || error);
    }


}